export enum TopicType {
  MainTopic = 'MainTopic',
  Region = 'Region',
  General = 'General'
}

export interface TopicDTOAdmin {
  id: number;
  name: string;
  logoUrl: string | null;
  type: TopicType;
  countryCode: string | null;
}

export interface TopicListResponse {
  topics: TopicDTOAdmin[];
  currentPage: number;
  totalPages: number;
  totalItems: number;
  pageSize: number;
}

export interface TopicUpdateRequestAdmin {
  id: number;
  name: string;
  logoUrl: string;
}

export interface HotTopicDTO {
  id: number;
  topic: string;
  iconUrl: string;
  searchQuery: string;
  countryCode: string | null;
  isGlobal: boolean;
  isActive: boolean;
}

export interface HotTopicCreateRequest {
  topic: string;
  iconUrl: string;
  searchQuery: string;
  countryCode?: string;
  isGlobal: boolean;
  isActive: boolean;
}

export interface HotTopicUpdateRequest {
  id: number;
  topic: string;
  iconUrl: string;
  searchQuery: string;
  countryCode?: string;
  isGlobal: boolean;
  isActive: boolean;
}

export interface RemoteConfigDTO {
  topicVersion: number;
  globalHotTopic: string | null;
  countryHotTopic: string | null;
}
